import GlossaryPlaceholder from '@/shared/assets/images/glossary.png';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';

import { LimitedFeatureContent, ModalContent } from '../types';
import { getBullets } from './bullets';
import { BULLETS_HEADER_TEXT, BUTTON_TEXTS } from './texts';

const BASE_CONTENT: ModalContent = {
  title: 'Unlock Translation dictionary',
  bulletsHeader: BULLETS_HEADER_TEXT.withBusiness,
  buttonText: BUTTON_TEXTS.choosePlan,
  features: getBullets([
    'translate500',
    'lipSync',
    'voiceCloneSettings',
    'voicePresets',
    'glossary',
    'srtUploadDownload',
    'subtitles',
    'aiRewrite',
    'simultaneousMultiLanguageTranslation',
    'api',
    'noWatermark',
  ]),
  media: {
    src: GlossaryPlaceholder,
    type: 'image',
  },
  mixpanelButtonClickEvent: MixpanelEvents.UpgradeDictionaryChoosePlanModalClick,
  //TODO: Add mixpanel event
  mixpanelOpeningEvent: MixpanelEvents.upgradeDictionaryModalShown,
  subtitle: 'Upgrade to Business to create Translation Dictionary',
};

const TRIAL_PLAN_CONTENT = {
  ...BASE_CONTENT,
};

const STARTER_PLAN_CONTENT = {
  ...BASE_CONTENT,
  bulletsHeader: BULLETS_HEADER_TEXT.inTrial,
};

const CREATOR_PLAN_CONTENT = {
  ...BASE_CONTENT,
  bulletsHeader: BULLETS_HEADER_TEXT.inCreator,
  features: getBullets([
    'translate500',
    'lipSync',
    'voiceCloneSettings',
    'voicePresets',
    'glossary',
    'srtUploadDownload',
    'subtitles',
    'aiRewrite',
    'simultaneousMultiLanguageTranslation',
    'api',
  ]),
};

const CREATOR_PRO_PLAN_CONTENT = {
  ...CREATOR_PLAN_CONTENT,
  bulletsHeader: BULLETS_HEADER_TEXT.inCreatorPro,
  features: getBullets(['translate500', 'glossary', 'voicePresets10', 'simultaneousMultiLanguageTranslation', 'api']),
};

export const GLOSSARY_CONTENT: LimitedFeatureContent = {
  creator: CREATOR_PLAN_CONTENT,
  creatorPro: CREATOR_PRO_PLAN_CONTENT,
  starter: STARTER_PLAN_CONTENT,
  trial: TRIAL_PLAN_CONTENT,
};
